/**
 * 基础设置相关API
 */

 import request from '@/utils/request'
 import md5 from 'js-md5'
 

 
 /**
  * 获取成员列表
  * @param params
  */
  export function getmenberList(params) {
    return request({
      url: '/admin',
      method: 'get',
      loading: false,
      params
    })
  }

 /**
  * 编辑成员
  * @param params
  */
  export function menberEdit(id,params) {
    params.password = params.password && md5(params.password)
    return request({
      url: `/admin/${id}`,
      method: 'put',
      loading: false,
      data:params,
      headers: { 'Content-Type': 'application/json' }
    })
  }

 /**
  * 新增成员
  * @param params
  */
  export function menberAdd(params) {
    params.password = md5(params.password)
    return request({
      url: '/admin',
      method: 'post',
      loading: false,
      data:params,
      headers: { 'Content-Type': 'application/json' },
    })
  }

 /**
  * 激活成员
  * @param id
  */
  export function menberActive(id) {
    return request({
      url: `/admin/${id}/start`,
      method: 'put',
      loading: false,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
  }

 /**
  * 禁用成员
  * @param id
  */
  export function menberStop(id) {
    return request({
      url: `/admin/${id}/stop`,
      method: 'put',
      loading: false,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
  }

/**
  * 删除成员
  * @param params
  */
 export function menberDelete(id) {
  return request({
    url: `/admin/${id}`,
    method: 'delete',
    loading: false,
    // data:params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}

 /**
  * 获取角色列表
  * @param params
  */
 export function getroleList(params) {
   return request({
     url: '/role',
     method: 'get',
     loading: false,
     params
   })
 }

 /**
  * 添加角色
  * @param params
  */
  export function addRole(params) {
    return request({
      url: '/role',
      method: 'post',
      isJson:true,
      loading: false,
      data:params
    })
  }

 /**
  * 修改角色
  * @param params
  */
  export function editRole(params) {
    return request({
      url: `/role/${params.role_id}`,
      method: 'put',
      isJson:true,
      loading: false,
      data:params
    })
  }

 /**
  * 删除角色
  * @param params
  */
  export function deleteRole(role_id) {
    return request({
      url: `/role/${role_id}`,
      method: 'delete',
      loading: false
    })
  }

/**
 * 获取菜单目录列表
 * @param params
 */
export function getmenuList(params) {
return request({
    url: '/menu',
    method: 'get',
    loading: false,
    params
})
}


/**
 * 获取树目录菜单
 * @param params
 */
export function getTreemenu() {
return request({
    url: '/menu/tree',
    method: 'get',
    loading: false,
})
}

/**
 * 获取角色目录菜单
 * @param params
 */
 export function getRoleMenu(role_id) {
    return request({
        url: `/menu/${role_id}`,
        method: 'get',
        loading: false,
    })
}

/**
 * 获取层级菜单
 * @param params
 */
 export function getLevelmenu(level) {
    return request({
        url: `/menu/${level}/level`,
        method: 'get',
        loading: false,
    })
    }

/**
 * 添加菜单目录
 * @param params
 */
 export function AddTreemenu(param) {
    return request({
        url: '/menu',
        method: 'post',
        loading: false,
        isJson:true,
        data:param
    })
 }

/**
 * 修改菜单目录
 * @param params
 */
 export function putTreemenu(param) {
    return request({
        url: `/menu/${param.menu_id}`,
        method: 'put',
        loading: false,
        isJson:true,
        data:param
    })
 }

/**
 * 删除菜单目录
 * @param params
 */
 export function deleteMenu(param) {
    return request({
        url: `/menu/${param.menu_id}`,
        method: 'delete',
        loading: false,
    })
 }


/**
 * 获取操作日志
 * @param params
 */
 export function getLogList(params) {
  return request({
      url: `/operate/log`,
      method: 'get',
      loading: false,
      params
  })
}
//  获取事项下拉框
export function getMatterTypeOptions(params) {
    return request({
      url: '/notification/matter-type/list',
      method: 'get',
      loading: false,
      params
    })
  }
 
  /**
   * 获取配置列表
   * @param params
   */
  export function getConfigList(params) {
    return request({
      url: '/notification/config/page',
      method: 'get',
      loading: false,
      params
    })
  }

  /**
   * 获取事项状态列表
   * @param params
   */
  export function getStatusList(params) {
    return request({
      url: '/notification/status/list',
      method: 'get',
      loading: false,
      params
    })
  }

  /**
   * 获取处理人列表
   * @param params
   */
  export function getHandlerList(params) {
    return request({
      url: '/notification/handler/list',
      method: 'get',
      loading: false,
      params
    })
  }

  /**
   * 新增通知配置
   * @param params
   */
  export function addConfig(params) {
    return request({
      url: '/notification/config',
      method: 'post',
      loading: false,
      isJson: true,
      data: params
    })
  }

  /**
   * 更新通知配置
   * @param id
   * @param params
   */
  export function updateConfig(id, params) {
    return request({
      url: `/notification/config/${id}`,
      method: 'put',
      loading: false,
      isJson: true,
      data: params
    })
  }

  /**
   * 删除通知配置
   * @param id
   */
  export function deleteConfig(id) {
    return request({
      url: `/notification/config/${id}`,
      method: 'delete',
      loading: false
    })
  }

  /**
   * 启用/禁用通知配置
   * @param id
   * @param params
   */
  export function toggleConfigEnable(id, params) {
    return request({
      url: `/notification/config/${id}/enable`,
      method: 'put',
      loading: false,
      data: params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }

  /**
   * 获取待办事项汇总
   * @param params
   */
  export function getTodoSummary(params) {
    return request({
      url: '/notification/todo/summary',
      method: 'get',
      loading: false,
      params
    })
  }

  /**
   * 获取待办事项总数
   * @param params
   */
  export function getTodoTotal(params) {
    return request({
      url: '/notification/todo/total',
      method: 'get',
      loading: false,
      params
    })
  }


// WEBPACK FOOTER //
// ./src/api/basic.js